import { render, staticRenderFns } from "./BubbleTip.vue?vue&type=template&id=32567431&scoped=true&"
var script = {}
import style0 from "./BubbleTip.vue?vue&type=style&index=0&id=32567431&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32567431",
  null
  
)

export default component.exports